import { landingApiRequest } from '@/lib/landing-api'
import type { GameCommand, MascotGamePayload } from './mascot-game-types'

export function fetchMascotGame(campaignId: number, signal?: AbortSignal) {
  return landingApiRequest<MascotGamePayload>(
    `/api/donor/campaigns/${campaignId}/mascot-game`,
    {
      signal,
      cache: 'no-store',
    }
  )
}

export function sendMascotGameCommand(campaignId: number, command: GameCommand) {
  return landingApiRequest<MascotGamePayload>(
    `/api/donor/campaigns/${campaignId}/mascot-game`,
    {
      method: 'POST',
      body: JSON.stringify(command),
    }
  )
}
